export default "__VITE_ASSET__BKB30ngY__"